
import { PhoneCall, Phone, Route, AlertTriangle, FileText, Bug, RefreshCw, PhoneIncoming } from 'lucide-react';
import { NavItem } from '../types';

const ivrItems: NavItem[] = [
  {
    title: 'IVR Management',
    path: '/app/ivr',
    icon: PhoneCall,
    requiredPermissions: ['ivr.read'],
    children: [
      {
        title: 'Phone Numbers',
        path: '/app/ivr/numbers',
        icon: Phone,
        requiredPermissions: ['ivr.read']
      },
      {
        title: 'IVR Menus',
        path: '/app/ivr/menus',
        icon: PhoneCall,
        requiredPermissions: ['ivr.read']
      },
      {
        title: 'Call Routing',
        path: '/app/ivr/routing',
        icon: Route,
        requiredPermissions: ['ivr.read']
      },
      {
        title: 'Error Log',
        path: '/app/ivr/error-logs',
        icon: AlertTriangle,
        requiredPermissions: ['ivr.read']
      },
      {
        title: 'Call Log',
        path: '/app/ivr/call-logs',
        icon: FileText,
        requiredPermissions: ['ivr.read']
      },
      {
        title: 'Log Sync',
        path: '/app/ivr/log-sync',
        icon: RefreshCw,
        requiredPermissions: ['ivr.read']
      },
      {
        title: 'Twilio Debug',
        path: '/app/ivr/debug',
        icon: Bug,
        requiredPermissions: ['ivr.read']
      },
      {
        title: 'Mock Calls',
        path: '/app/ivr/mock-calls',
        icon: PhoneIncoming,
        requiredPermissions: ['ivr.read']
      }
    ]
  }
];

export default ivrItems;
